module.exports = __webpack_public_path__ + "img/city.7da084ac.png";